import { render, staticRenderFns } from "./ChatsByDevice.vue?vue&type=template&id=47badc84&"
import script from "./ChatsByDevice.vue?vue&type=script&lang=js&"
export * from "./ChatsByDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports